module.exports = __webpack_public_path__ + "static/media/ubicacion.2c6ee7bc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/ubicacion.svg
// module id = 90
// module chunks = 0